import { render, staticRenderFns } from "./CommercialProductTransferModal.vue?vue&type=template&id=0ec509ac&lang=html&"
import script from "./CommercialProductTransferModal.vue?vue&type=script&lang=js&"
export * from "./CommercialProductTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./CommercialProductTransferModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports